import { render, staticRenderFns } from "./ComponentDetailHeader.vue?vue&type=template&id=2ddbc2cc&scoped=true"
import script from "./ComponentDetailHeader.vue?vue&type=script&lang=js"
export * from "./ComponentDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./ComponentDetailHeader.vue?vue&type=style&index=0&id=2ddbc2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbc2cc",
  null
  
)

export default component.exports